export const INITIALIZE = 'C_TOP_NAV.INITIALIZE';
export const SET_ERRORS = 'C_TOP_NAV.SET_ERRORS';
export const SET_WORKFLOW = 'C_TOP_NAV.SET_WORKFLOW';
export const REFRESH_NAVIGATION = 'C_TOP_NAV.REFRESH_NAVIGATION';

export const initialize = (currentClient, isConsumerArea) => ({
  type: INITIALIZE,
  currentClient,
  isConsumerArea,
});

export const set_errors = errors => ({
  type: SET_ERRORS,
  errors,
});

export const refresh_navigation = () => ({
  type: REFRESH_NAVIGATION,
});

export const set_workflow = workflow => ({
  type: SET_WORKFLOW,
  workflow,
});

window.ADV.consumer = Object.assign(window.ADV.consumer || {}, {
  set_workflow(workflow) {
    ADV.store.dispatch(set_workflow(workflow));
  },
  refresh_navigation() {
    ADV.store.dispatch(refresh_navigation());
  },
});
